import { createElement, FunctionComponent, memo, SVGProps } from "react";
import classnames from "classnames";

import styles from "./style.module.scss";

type ArrowBtnProps = {
  icon: FunctionComponent<SVGProps<SVGSVGElement>>,
  onClick: () => void,
  disable?: boolean
}

export const ArrowBtn = memo<ArrowBtnProps>(({ icon, onClick, disable }) => (
  <button
    type="button"
    tabIndex={-1}
    onClick={onClick}
    className={classnames(styles.arrow, { [styles.disabledArrow]: disable })}
  >
    {createElement(icon)}
  </button>
));
